export default __webpack_public_path__ + "1c886c32af6e0fd7af29ff2d9f3f855c.png";